import { render, staticRenderFns } from "./FormEditBuilder.vue?vue&type=template&id=31e5291a&scoped=true"
import script from "./FormEditBuilder.vue?vue&type=script&lang=js"
export * from "./FormEditBuilder.vue?vue&type=script&lang=js"
import style0 from "./FormEditBuilder.vue?vue&type=style&index=0&id=31e5291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5291a",
  null
  
)

export default component.exports